export default {"src":"/_next/static/media/gender.73dc0f88.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};